import React, { Component } from "react";
import { Container, Col, Button, Input, Row, Modal } from "reactstrap";
import LoadingOverlay from "react-loading-overlay";
// import GooglePlacesAutocomplete from "react-google-places-autocomplete";
// import { geocodeByAddress } from "react-google-places-autocomplete";
import Geocode from "react-geocode";
// set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
import RequestManager from "../../singletons/RequestManager/RequestManager";
// import "react-google-places-autocomplete/dist/index.min.css";
import config from "../../config";
import ErrorTokenMiss from "../../components/ErrorTokenMiss/ErrorTokenMiss";
import { InlineShareButtons } from "sharethis-reactjs";
import { CopyToClipboard } from "react-copy-to-clipboard";
import domtoimage from "dom-to-image";
import AccountDetails from '../../components/AccountDetails/AccountDetails';
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../utils/helper";

var QRCode = require("qrcode.react");
let requestManager = new RequestManager();
export default class StoreDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: "",
      position: {
        lat: 0,
        lng: 0,
      },
      placeName: "",
      roomMen: "",
      spinnerLoading: false,
      bussinessDomains: null,
      rooms: null,
      defaultRoom: "",
      tokenMissmatchModalVisible: false,
      tokenErrorMessage: "",
      password: "",
      confirmPassword: "",
      email: "",
      userName: "",
      storeContactNumber: "",
      phoneNumber: "",
      showCamera: false,
      dataUri: "",
      image: "",
      city: "",
      storeUrl: "",
      customUrlOrginal: "",
      customUrlFullString: "",
      store:null,
      accountNo: "",
      accountName: "",
      accountVerified: "",
      gstNo: "",
      ifsccode: "",
    };
    // this.onDrop = this.onDrop.bind(this);
    // this.onTakePhotoAnimationDone = this.onTakePhotoAnimationDone.bind(this);
    // this.onImageChange = this.onImageChange.bind(this);
  }

  componentDidMount() {
    // Asia/Kolkata
    Geocode.setApiKey("AIzaSyAqNIsWwmxw_6_gGfZvh4OT1V09ick5s78");

    // set response language. Defaults to english.
    Geocode.setLanguage("en");
    
    this.checkLoginMode();
    this.getAccountDetails();
  }
  getAccountDetails = async () => {
    let loginMode = localStorage.getItem("loginMode");
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let params = {};
    params = {
      storeId : storeInformation.store.id
    }
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getAccountdetails",
      params
    );
    if (response.error) {
      //alert('Something went wrong. Please try again later.')
    } else {
      let res = JSON.parse(JSON.stringify(response));
      console.log("getUserProfile", JSON.stringify(res.data));
      if (res.data.store !== null) {
        this.setState({
          store: res.data.store,
          accountNo: res.data.store.accountNo,
          accountName: res.data.store.accountName,
          accountVerified: res.data.store.accountVerified,
          gstNo: res.data.store.gstNo,
          ifsccode: res.data.store.ifsccode,
        })
      } 
    }
  }
  checkLoginMode = () => {
    let loginMode = localStorage.getItem("loginMode");
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    console.log("storeInformation", JSON.stringify(storeInformation));
    let storeName = "";
    if (loginMode === "store") {
      storeName = storeInformation.store && storeInformation.store.name;
    } else if (loginMode === "merchant") {
      storeName = storeInformation.merchant && storeInformation.merchant.name;
    } else if (loginMode === "concessionaire") {
      storeName = "Concessionaire";
    }
    let customUrl = "https://getnear.me/store/";
    if (storeInformation.store && storeInformation.store.customUrl !== null) {
      customUrl = customUrl + storeInformation.store.customUrl;
    }

    this.setState({
      image: storeInformation.store.image,
      email: storeInformation.store.email,
      phoneNumber: storeInformation.store.phones,
      address: storeInformation.store.address,
      customUrlOrginal: storeInformation.store.customUrl,
      customUrlFullString: customUrl,
      storeUrl: storeInformation.store.customUrl,
      businessDomainId: storeInformation.store.businessDomain.name,
      loginMode: loginMode,
      canStoreOpen:
        storeInformation.store && storeInformation.store.canMarkOpen,
      printSdkType:
        storeInformation.store && storeInformation.store.printSdkType,
      placeName: storeName,
    });
    console.log(loginMode);
    if (loginMode === "store") {
      this.getStoreDetails();
    }
  };
  getStoreDetails = async () => {
    let params = {};
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getUserProfile",
      params
    );
    if (response.error) {
      //alert('Something went wrong. Please try again later.')
    } else {
      let res = JSON.parse(JSON.stringify(response));
      console.log("getUserProfile", JSON.stringify(res.data));
      if (res.data.userProfile.user.store === null) {
      } else {
        // let customUrl = "https://getnear.me/store/";
        let customUrl = "";
        if (
          res.data.userProfile.user.store &&
          res.data.userProfile.user.store.customUrl !== null
        ) {
          customUrl = customUrl + res.data.userProfile.user.store.customUrl;
        }
        this.setState({
          customUrlOrginal: customUrl,
          isOpen: res.data.userProfile.user.store.isOpen,
          customUrlFullString: customUrl,
        });
      }
    }
  };
  handleLocationChange = (position, address, places) => {
    // Set new location
    this.setState({ position, address });
  };

  getBussinessDomains = async () => {
    let authToken = localStorage.getItem("authToken");
    let params = {};

    let requestManager = new RequestManager();
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getBussinessDomains",
      params,
      authToken
    );
    console.log("getBussinessDomains", JSON.stringify(response));
    if (response.error === null) {
      this.setState({
        bussinessDomains: response.data.businessDomains.edges,
        selectedBussinessId: response.data.businessDomains.edges[0].node.id,
      });
    }
  };

  updateAccountVerified = async() =>{
    let requestManager = new RequestManager();
    let params;
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));  
    

      params ={
      input: {
        id: storeInformation.store.id,
        accountVerified:true
        }
      }  
    

   
  let response =await requestManager.getResponseFromPredefinedQuery(
      "updateStoreAccountDetails",
      params
  );

    if (response.error === null) {
      this.setState({accountVerified:true})
      console.log('Account Verified')
    }else
    {
      console.log('Account NOT Verified')
    }
  }

  toggleErrorTokenMissModal = (text) => {
    this.setState({
      tokenMissmatchModalVisible: !this.state.tokenMissmatchModalVisible,
      tokenErrorMessage: text,
    });
  };
  render() {
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Modal
          size="lg"
          isOpen={this.state.tokenMissmatchModalVisible}
          toggle={this.toggleErrorTokenMissModal}
        >
          <ErrorTokenMiss
            editable={true}
            tokenErrorMessage={this.state.tokenErrorMessage}
            goBack={this.toggleErrorTokenMissModal}
          />
        </Modal>
        <div>
          <Container style={{ margin: 10 }}>
            <Row className="justify-content-center">
              <h1>{"Store Details"}</h1>
            </Row>
            {this.state.showCamera === false ? (
              <Row className="justify-content-center">
                <img
                  style={{
                    width: 200,
                    height: this.state.image === "" ? 60 : 100,
                    margin: 10,
                    objectFit: "contain",
                  }}
                  alt={""}
                  src={
                    this.state.image === ""
                      ? require("../../assets/img/brand/yourlogo.png")
                      : this.state.image
                  }
                />
              </Row>
            ) : null}
            <Row className="justify-content-center">
              <Button
                style={{ backgroundColor: "#ff5000", color: "white" }}
                onClick={() => {
                  // this.setState({ showCamera: true });
                }}
              >
                Logo (Edit)
              </Button>
            </Row>
            {this.state.showCamera === true ? (
              <input type="file" name="myImage" onChange={this.onImageChange} />
            ) : null}
            {
              // <Row
              //   xs="12"
              //   sm="12"
              //   md="4"
              //   lg="4"
              //   style={{ display: "flex", alignItems: "center", margin: 10 }}
              // >
              //   <p
              //     style={{
              //       fontSize: 20,
              //     }}
              //   >
              //     {"User name"}
              //   </p>
              //   <Input
              //     type="text"
              //     style={{
              //       height: 40,
              //       width: "95%",
              //       fontSize: 16,
              //       color: "black",
              //     }}
              //     placeholder="Enter user name"
              //     value={this.state.userName}
              //     onChange={(event) => {
              //       this.setState({ userName: event.target.value });
              //     }}
              //   />
              // </Row>
            }
            <Row >
              <Col xs="2"><p style={{fontSize:14}}>{"Business Name"}</p></Col>
              <Col xs="8">
              <Input type="text" style={{height: 40,width: "100%",fontSize: 16,color: "black",}}
                placeholder="Enter bussiness name"
                value={this.state.placeName}
                onChange={(event) => {
                  this.setState({ placeName: event.target.value });
                }}
              />
              </Col>
            </Row>

            <Row >
              <Col xs="2"><p style={{fontSize:14}}>{"Phone Number"}</p></Col>
              <Col xs="8">
              <Input type="number" style={{height: 40,width: "100%",fontSize: 14,color: "black",}}
                placeholder="Enter phone number"
                value={this.state.phoneNumber}
                onChange={(event) => {
                  this.setState({ phoneNumber: event.target.value });
                }}
              />
              </Col>
            </Row>

            <Row >
              <Col xs="2"><p style={{fontSize:14}}>{"Email"}</p></Col>
              <Col xs="8">
              <Input type="text" style={{height: 40,width: "100%",fontSize: 14,color: "black",}}
                placeholder="Enter email"
                value={this.state.email}
                onChange={(event) => {
                  this.setState({ email: event.target.value });
                }}
              />
              </Col>
            </Row>
          
            <Row >
              <Col xs="2"><p style={{fontSize:14}}>{"Address"}</p></Col>
              <Col xs="8">
              <Input type="text" style={{height: 40,width: "100%",fontSize: 14,color: "black",}}
                placeholder="Enter address"
                value={this.state.address}
                onChange={(event) => {
                  this.setState({ address: event.target.value });
                }}
              />
              </Col>
            </Row>
            <Row >
              <Col xs="2"><p style={{fontSize:14}}>{"Store Custom URL"}</p></Col>    
              <Col  xs="6">
              <Input type="text" disabled={true} style={{height: 40,width: "100%",fontSize: 14,color: "black",}}
                placeholder="Enter custom url"
                value={this.state.customUrlFullString}
              />
              </Col>
              <Col  xs="2">
              <CopyToClipboard
                style={{
                  backgroundColor: "#ff5000",
                  padding: 10,
                  marginTop: 50,
                  marginLeft: 10,
                  color: "white",
                  borderWidth: 1,
                  borderRadius: 8,
                }}
                text={this.state.customUrlFullString}
                onCopy={() => this.toggleErrorTokenMissModal("Copied")}
              >
                <span>Copy</span>
              </CopyToClipboard>
              </Col>
            </Row>
   
            <Row >
              <Col xs="2"><p style={{fontSize:14}}>{"Bussiness Type"}</p></Col>    
              <Col  xs="8">
              <Input type="text" disabled={true} style={{height: 40,width: "100%",fontSize: 14,color: "black",}}                placeholder="Enter bussiness name"
                value={this.state.businessDomainId}
                onChange={(event) => {
                  this.setState({ businessDomainId: event.target.value });
                }}
              />
              </Col>
            </Row>
            <Row >
              <Col xs="2"><p style={{fontSize:14}}>{"Account Details"}</p></Col>    
            </Row>
            <Row >
              <Col xs="2"><p style={{fontSize:14}}>{"Account Name"}</p></Col>    
              <Col  xs="8">
              <Input type="text" disabled={true} style={{height: 40,width: "100%",fontSize: 14,color: "black",}} placeholder="Account Name"
                value={this.state.accountName}
                onChange={(event) => {
                  this.setState({ accountName: event.target.value });
                }}
              />
              </Col>
            </Row>
            <Row >
              <Col xs="2"><p style={{fontSize:14}}>{"Account Number"}</p></Col>    
              <Col  xs="8">
              <Input type="text" disabled={true} style={{height: 40,width: "100%",fontSize: 14,color: "black",}} placeholder="Account Number"
                value={this.state.accountNo}
                onChange={(event) => {
                  this.setState({ accountNo: event.target.value });
                }}
              />
              </Col>
            </Row>
            <Row >
              <Col xs="2"><p style={{fontSize:14}}>{"IFSC CODE"}</p></Col>    
              <Col  xs="8">
              <Input type="text" disabled={true} style={{height: 40,width: "100%",fontSize: 14,color: "black",}} placeholder="IFSC Code"
                value={this.state.ifsccode}
                onChange={(event) => {
                  this.setState({ ifsccode: event.target.value });
                }}
              />
              </Col>
            </Row>
            <Row >
              <Col xs="2"><p style={{fontSize:14}}>{"GST"}</p></Col>    
              <Col  xs="8">
              <Input type="text" disabled={true} style={{height: 40,width: "100%",fontSize: 14,color: "black",}}  placeholder="GST No"
                value={this.state.gstNo}
                onChange={(event) => {
                  this.setState({ gstNo: event.target.value });
                }}
              />
              </Col>
            </Row>
            <Row >
              <Col xs="10">
                {this.state.store &&(
                <AccountDetails store={this.state.store}/>
                )}
                </Col> 
             </Row>
             <Row>      
              <Col  xs="10">
              {(this.state.accountVerified != undefined && this.state.accountVerified == false && this.state.accountName != null && this.state.accountNo !=null && this.state.ifsccode !=null && this.state.gstNo !=null) && (
              <Button
                  style={{height: 40,backgroundColor: "#25D466",color: "white",width:"100%"}}
                  onClick={this.updateAccountVerified}
                >
                  {"Verify Account"}
                </Button>
                )}
              </Col>

            </Row>  
          {(this.state.customUrlFullString.length > 10 && this.state.customUrlFullString != undefined) && (
            <div>
              <Row >
                <Col xs="2"><p style={{fontSize:14}}>{"QR Code"}</p></Col>    
              </Row>
              <Row
              style={{
                margin: 10,
                background: "white",
                padding: 10,
              }}
              className="justify-content-center"
            >
              <Row
                className="justify-content-center"
                style={{
                  marginBottom: 20,
                  marginTop: 20,
                  marginLeft: 10,
                  marginRight: 10,
                }}
              >
                <QRCode
                  value={this.state.customUrlFullString}
                  style={{ width: 100, height: 100, backgroundColor: "white" }}
                  id={"my-node"}
                />
              </Row>
              <Row
                className="justify-content-center"
                style={{
                  marginLeft: 10,
                  marginRight: 10,
                  alignItems: "center",
                }}
              >
                <Button
                  style={{
                    marginRight: 10,
                    marginBottom: 20,
                    height: 40,
                    backgroundColor: "#ff5000",
                    color: "white",
                  }}
                  onClick={() => {
                    let placeName = this.state.storeName;
                    domtoimage
                      .toJpeg(document.getElementById("my-node"), {
                        quality: 0.95,
                        height: 100,
                        backgroundColor: "#ff5000",
                        width: 100,
                      })
                      .then(function (dataUrl) {
                        var link = document.createElement("a");
                        link.download = placeName + ".jpeg";
                        link.href = dataUrl;
                        link.click();
                      });
                  }}
                >
                  {"Download (100*100)"}
                </Button>
                <Button
                  style={{
                    marginRight: 10,
                    height: 40,
                    marginBottom: 20,
                    backgroundColor: "#ff5000",
                    color: "white",
                  }}
                  onClick={() => {
                    let placeName = this.state.storeName;
                    domtoimage
                      .toJpeg(document.getElementById("my-node"), {
                        quality: 0.95,
                        height: 300,
                        backgroundColor: "white",
                        padding: 10,
                        width: 300,
                      })
                      .then(function (dataUrl) {
                        var link = document.createElement("a");
                        link.download = placeName + ".jpeg";
                        link.href = dataUrl;
                        link.click();
                      });
                  }}
                >
                  {"Download (300*300)"}
                </Button>
              </Row>
            {/* {(this.state.customUrlFullString.length > 10 && this.state.customUrlFullString != undefined) && ( */}
              
            <InlineShareButtons
              className="justify-content-center"
              style={{ marginLeft: 10 }}
              config={{
                alignment: "center", // alignment of buttons (left, center, right)
                color: "social", // set the color of buttons (social, white)
                enabled: true, // show/hide buttons (true, false)
                font_size: 16, // font size for the buttons
                labels: "cta", // button labels (cta, counts, null)
                language: "en", // which language to use (see LANGUAGES)
                networks: [
                  // which networks to include (see SHARING NETWORKS)
                  "whatsapp",
                  "linkedin",
                  "messenger",
                  "facebook",
                  "twitter",
                ],
                padding: 12, // padding within buttons (INTEGER)
                radius: 4, // the corner radius on each button (INTEGER)
                show_total: false,
                size: 40, // the size of each button (INTEGER)
                // OPTIONAL PARAMETERS
                url: "*" + this.state.placeName + "*" + ' Welcome to our store on Near Me. YoU order We deliver ' + this.state.customUrlFullString, // (defaults to current url)
                image: this.state.image, // (defaults to og:image or twitter:image)
                //description: 'Welcome to our store on Near Me. You order We deliver', // (defaults to og:description or twitter:description)
                //title: this.state.placeName, // (defaults to og:title or twitter:title)
                //message: "custom email text", // (only for email sharing)
                // subject: "custom email subject", // (only for email sharing)
                // username: "custom twitter handle", // (only for twitter sharing)
              }}
              
              
            />
         
          </Row>
          </div>
    )}

            <Row className="justify-content-center">
              <Button
                style={{
                  marginRight: 20,
                  marginBottom: 20,
                  backgroundColor: "#ff5000",
                  color: "white",
                }}
                onClick={() => {
                  //this.uploadFile();
                  //   this.validationPalce();
                }}
              >
                {"Save"}
              </Button>
            </Row>
          </Container>
        </div>
      </LoadingOverlay>
    );
  }

  addRooms = () => {
    if (this.state.rooms === null) {
      let rooms = [];
      let val = { name: "", id: 1 };
      rooms.push(val);
      this.setState({ rooms: rooms });
    } else {
      let rooms = this.state.rooms;
      let len = this.state.rooms.length;
      let val = { name: "", id: len + 1 };
      rooms.push(val);
      this.setState({ rooms: rooms });
    }
  };
  updateRooms = (id, name) => {
    let rooms = this.state.rooms;

    let len = this.state.rooms.length;
    for (let i = 0; i < len; i++) {
      if (rooms[i].id === id) {
        rooms[i].name = name;
      }
    }

    this.setState({ rooms: rooms });
  };
  deleteRooms = (id) => {
    let rooms = this.state.rooms;
    let len = this.state.rooms.length;
    let room = [];
    for (let i = 0; i < len; i++) {
      if (rooms[i].id === id) {
      } else {
        room.push(rooms[i]);
      }
    }
    this.setState({ rooms: room });
  };
  handleChange = (event) => {
    for (let i = 0; i < this.state.bussinessDomains.length; i++) {
      if (this.state.bussinessDomains[i].node.name === event.target.value) {
        this.setState({
          selectedBussiness: event.target.value,
          selectedBussinessId: this.state.bussinessDomains[i].node.id,
        });
        break;
      }
    }
  };
  getUserProfile = async () => {
    let params = {};
    let requestManager = new RequestManager();
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getUserProfile",
      params
    );
    console.log("getUserProfile", JSON.stringify(response));
    if (response.error) {
      // alert('Something went wrong. Please try again later.')
    } else {
      let res = response;

      localStorage.setItem("userProfile", JSON.stringify(res.data.userProfile));
    }
  };

  SingleUpdateCategoryProductStockSku = async (params) => {
    let requestManager = new RequestManager();
    // let input = {
    //   input: {
    //     merchantId:
    //       "TWVyY2hhbnQ6ZGFhYTM2ZjItYWNmZS00MjE3LTkxMWUtZGRhM2RkOWIzNjA0",
    //     storeId: "U3RvcmU6ZTlkMzFiZDAtMDczNy00ZTA2LThjYzYtN2EyZWRlZTQ3NmZl",
    //     name: "Womens",
    //     businessDomainId:
    //       "QnVzaW5lc3NEb21haW46YWEzZWJkNDYtMGE5MC00OTQ3LWE4MjMtN2Y2MGRlODNhNGIz",
    //     categoryName: "Slot booking",
    //   },
    // };

    let response = await requestManager.getResponseFromPredefinedQuery(
      "UpdateCategoryProductStockSku",
      params
    );

    console.log("UpdateCategoryProductStockSku", JSON.stringify(response));
    localStorage.setItem("RoomCreated", "Yes");
    localStorage.setItem("loginMode", "store");
    this.props.history.push("/workinghourcapacity");
  };
  UpdateCategoryProductStockSku = async (params, done) => {
    let requestManager = new RequestManager();
    // let input = {
    //   input: {
    //     merchantId:
    //       "TWVyY2hhbnQ6ZGFhYTM2ZjItYWNmZS00MjE3LTkxMWUtZGRhM2RkOWIzNjA0",
    //     storeId: "U3RvcmU6ZTlkMzFiZDAtMDczNy00ZTA2LThjYzYtN2EyZWRlZTQ3NmZl",
    //     name: "Womens",
    //     businessDomainId:
    //       "QnVzaW5lc3NEb21haW46YWEzZWJkNDYtMGE5MC00OTQ3LWE4MjMtN2Y2MGRlODNhNGIz",
    //     categoryName: "Slot booking",
    //   },
    // };

    let response = await requestManager.getResponseFromPredefinedQuery(
      "UpdateCategoryProductStockSku",
      params
    );
    console.log("UpdateCategoryProductStockSku", JSON.stringify(response));
    if (done) {
      localStorage.setItem("RoomCreated", "Yes");
      localStorage.setItem("loginMode", "store");
      this.props.history.push("/workinghourcapacity");
    }
  };

  validationPalce = () => {
    // if (this.state.userName.length <= 2) {
    //   this.toggleErrorTokenMissModal("Enter atleast two letters");

    //   return;
    // }

    if (this.state.placeName.length <= 2) {
      this.toggleErrorTokenMissModal("Enter valid bussiness name.");

      return;
    }
    if (this.state.phoneNumber.length !== 10) {
      this.toggleErrorTokenMissModal("Enter valid phone number");

      return;
    }

    if (this.state.password.length <= 2) {
      this.toggleErrorTokenMissModal("Enter password atleast 2 characters");

      return;
    }
    if (this.state.confirmPassword.length <= 2) {
      this.toggleErrorTokenMissModal(
        "Enter confirm password atleast 2 characters"
      );

      return;
    }
    if (this.state.confirmPassword !== this.state.password) {
      this.toggleErrorTokenMissModal("Password missmatch");

      return;
    }

    if (this.state.storeContactNumber.length !== 10) {
      this.toggleErrorTokenMissModal("Enter valid store contact number");

      return;
    }

    if (this.state.address.length <= 2) {
      this.toggleErrorTokenMissModal("Enter valid address.");

      return;
    }
    if (this.state.storeUrl.length <= 2) {
      this.toggleErrorTokenMissModal("Enter valid custom store url.");

      return;
    }
    // if (this.state.city.length <= 2) {
    //   this.toggleErrorTokenMissModal("Enter valid city.");

    //   return;
    // }
    Geocode.fromAddress(this.state.address).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        console.log(response);
        console.log(lat, lng);

        this.createStore(lat, lng);
      },
      (error) => {
        this.toggleErrorTokenMissModal("Not valid address");
        console.error(error);
      }
    );
    // this.checkStore();
  };
  
  getMerchantProfile = async () => {
    let params = {};
    let requestManager = new RequestManager();
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getUserProfile",
      params
    );
    console.log("getUserProfile", JSON.stringify(response));
    if (response.error) {
      // alert('Something went wrong. Please try again later.')
    } else {
      let res = response;

      localStorage.setItem("userProfile", JSON.stringify(res.data.userProfile));

      let userProfile = JSON.parse(localStorage.getItem("userProfile"));

      if (this.state.rooms === null) {
        let input = "";
        if (this.state.roomMen === "") {
          input = {
            input: {
              merchantId: userProfile.user.store.merchant.id,
              storeId: userProfile.user.store.id,
              name: this.state.placeName + "-" + this.state.area,
              businessDomainId: userProfile.user.store.businessDomain.id,
              categoryName: "Slot booking",
            },
          };
        } else {
          input = {
            input: {
              merchantId: userProfile.user.store.merchant.id,
              storeId: userProfile.user.store.id,
              name: this.state.roomMen,
              businessDomainId: userProfile.user.store.businessDomain.id,
              categoryName: "Slot booking",
            },
          };
        }

        this.SingleUpdateCategoryProductStockSku(input);
      } else {
        if (this.state.rooms !== null) {
          for (let i = 0; i < this.state.rooms.length; i++) {
            let input = {
              input: {
                merchantId: userProfile.user.store.merchant.id,
                storeId: userProfile.user.store.id,
                name: this.state.rooms[i].name,
                businessDomainId: userProfile.user.store.businessDomain.id,
                categoryName: "Slot booking",
              },
            };
            if (i === this.state.rooms.length - 1)
              this.UpdateCategoryProductStockSku(input, true);
            else {
              this.UpdateCategoryProductStockSku(input, false);
            }
          }
        }
      }
    }
  };
  updateStore =  async() =>{
    this.setState({ spinnerLoading: true });
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    var vtimestamp = generateEpochTimestamp();    
    fetch(config.getHost() + "/product/create-merchant-store-pickuppoint/", {
      method: "POST",
      headers: {
        Authorization: `Token ${authToken}`,
        "Content-Type": "application/json",
        Timestamp: vtimestamp,
        Signature: generateSignature(vtimestamp, authToken)            
      },
      body: JSON.stringify({
        n_user_id: "",
        n_entity_name: this.state.placeName,
        n_address: this.state.address,
        n_area: "",
        n_city: this.state.city,
        n_country: "IN",
        n_phone: "+91" + this.state.phoneNumber,
        n_email: this.state.email,
        n_password: this.state.password,
        n_user_name: this.state.userName,
        n_timezone: "Asia/Kolkata",
        n_business_domain_id: this.state.selectedBussinessId,
      }),
    })
      .then(async (response) => {
        console.log("Response", response);
        if (response.status === 200) {
          let json = await response.json();
          this.setState({ spinnerLoading: false });
          this.toggleErrorTokenMissModal("Successfully registered.");

          console.log("json", json);
        } else {
          this.toggleErrorTokenMissModal("Something went wrong,try again.");
          this.setState({ spinnerLoading: false });
        }
      })
      .catch((err) => {
        this.toggleErrorTokenMissModal("Something went wrong,try again.");
        this.setState({ spinnerLoading: false });
        console.log("error ", err);
      });
  };

  
  createStore = async (lat, lng) => {
    this.setState({ spinnerLoading: true });
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    var vtimestamp = generateEpochTimestamp();    
    console.log(
      JSON.stringify({
        n_user_id: "",
        n_entity_name: this.state.placeName,
        n_address: this.state.address,
        n_area: "",
        n_city: this.state.city,
        n_country: "IN",
        n_longitude: lng,
        n_latitude: lat,
        n_phone: "+91" + this.state.phoneNumber,
        n_email: this.state.email,
        n_password: this.state.password,
        n_user_name: this.state.userName,
        n_timezone: "Asia/Kolkata",
        n_business_domain_id: this.state.selectedBussinessId,
      })
    );
    fetch(config.getHost() + "/product/create-merchant-store-pickuppoint/", {
      method: "POST",
      headers: {
        Authorization: `Token ${authToken}`,
        "Content-Type": "application/json",
        Timestamp: vtimestamp,
        Signature: generateSignature(vtimestamp, authToken)            
      },
      body: JSON.stringify({
        n_user_id: "",
        n_entity_name: this.state.placeName,
        n_address: this.state.address,
        n_area: "",
        n_city: this.state.city,
        n_country: "IN",
        n_longitude: lng,
        n_latitude: lat,
        n_phone: "+91" + this.state.phoneNumber,
        n_email: this.state.email,
        n_password: this.state.password,
        n_user_name: this.state.userName,
        n_timezone: "Asia/Kolkata",
        n_business_domain_id: this.state.selectedBussinessId,
      }),
    })
      .then(async (response) => {
        console.log("Response", response);
        if (response.status === 200) {
          let json = await response.json();
          this.setState({ spinnerLoading: false });
          this.toggleErrorTokenMissModal("Successfully registered.");

          console.log("json", json);
        } else {
          this.toggleErrorTokenMissModal("Something went wrong,try again.");
          this.setState({ spinnerLoading: false });
        }
      })
      .catch((err) => {
        this.toggleErrorTokenMissModal("Something went wrong,try again.");
        this.setState({ spinnerLoading: false });
        console.log("error ", err);
      });
  };
}



// WEBPACK FOOTER //
// ./src/pages/StoreDetails/StoreDetails.js